var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 11,
    viewBox: "0 0 14 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0.25C7.32812 0.25 7.63281 0.4375 7.79688 0.71875L12.8594 9.34375C13.0234 9.64844 13.0234 10 12.8594 10.2812C12.6953 10.5859 12.3906 10.75 12.0625 10.75H1.9375C1.58594 10.75 1.28125 10.5859 1.11719 10.2812C0.953125 10 0.953125 9.64844 1.11719 9.34375L6.17969 0.71875C6.34375 0.4375 6.64844 0.25 7 0.25ZM7 3.25C6.67188 3.25 6.4375 3.50781 6.4375 3.8125V6.4375C6.4375 6.76562 6.67188 7 7 7C7.30469 7 7.5625 6.76562 7.5625 6.4375V3.8125C7.5625 3.50781 7.30469 3.25 7 3.25ZM7.75 8.5C7.75 8.10156 7.39844 7.75 7 7.75C6.57812 7.75 6.25 8.10156 6.25 8.5C6.25 8.92188 6.57812 9.25 7 9.25C7.39844 9.25 7.75 8.92188 7.75 8.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWarning);
export default __webpack_public_path__ + "static/media/icon-warning.e8142500d7b5d4593b5d0ad426dd3384.svg";
export { ForwardRef as ReactComponent };